"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { ArrowUp, Instagram, Linkedin, MapPin } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  const currentYear = new Date().getFullYear();
  const siteMap = [{
    label: "Home",
    href: "/HomePage"
  }, {
    label: "Onze Werkwijze",
    href: "/OurMethodPage"
  }, {
    label: "Contact",
    href: "/ContactPage"
  }, {
    label: "Privacy Policy",
    href: "#"
  }, {
    label: "Voorwaarden",
    href: "#"
  }];
  return <section data-section-id="4788" id="footer" ref={ref} className={`dark bg-background text-foreground py-16 sm:py-24 relative overflow-hidden transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.05]">
        <div className="absolute left-8 top-0 bottom-0 w-px bg-primary/30 hidden md:block" />
        <div className="absolute right-8 top-0 bottom-0 w-px bg-primary/30 hidden md:block" />
        <div className="absolute left-1/3 top-0 bottom-0 w-px bg-primary/30 hidden lg:block" />
        <div className="absolute right-1/3 top-0 bottom-0 w-px bg-primary/30 hidden lg:block" />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 mb-16">
          {}
          <div className="lg:col-span-5 flex flex-col justify-between">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold tracking-wider text-foreground mb-2">
                North Websites
              </h2>
              <div className="flex items-center gap-2 text-muted-foreground text-lg">
                <MapPin className="w-5 h-5 text-secondary" />
                <span>Den haag, Nederland</span>
              </div>
            </div>
            <div className="mt-8 lg:mt-auto">
              <p className="text-muted-foreground max-w-md leading-relaxed">
                Wij ontwerpen en realiseren krachtige digitale oplossingen voor 
                ondernemers die online impact willen maken. Snel, responsief 
                en technisch superieur.
              </p>
            </div>
          </div>

          {}
          <div className="lg:col-span-4">
            <h3 className="text-xs font-semibold uppercase tracking-widest text-secondary mb-6">
              North Websites
            </h3>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {siteMap.map((item, i) => <li key={item.label} data-index={i}>
                  <Link to={item.href} className="text-foreground/80 hover:text-primary transition-colors duration-200 flex items-center gap-2 group">
                    <span className="w-1.5 h-1.5 rounded-full bg-secondary/40 group-hover:bg-secondary transition-colors" />
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="lg:col-span-3 flex flex-col lg:items-end">
            
            
          </div>
        </div>

        <Separator className="bg-white/5 mb-8" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 text-sm text-muted-foreground">
          <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8">
            <span className="tracking-wide">
              &copy; {currentYear} North Websites. Alle rechten voorbehouden.
            </span>
            <span className="hidden md:inline text-white/10">|</span>
            <span className="italic opacity-60 font-mono text-xs uppercase tracking-tighter">
              Crafting digital excellence
            </span>
          </div>

          <Button onClick={scrollToTop} variant="outline" size="icon" className="rounded-full w-12 h-12 border-white/10 hover:bg-gradient-to-br hover:from-primary hover:to-secondary hover:text-white hover:border-transparent transition-all duration-500 shadow-xl" aria-label="Terug naar boven">
            <ArrowUp className="w-5 h-5" />
          </Button>
        </div>
      </div>
    </section>;
}